"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRateOverrides = void 0;
const models_1 = require("./models");
const OR_LOGICAL_OPERATOR_MATCH_REQUIREMENT = 1;
function filterRateOverrides(options, overrides) {
    return overrides.filter(rule => doesOverrideMatchInsurance(rule.optionsMatchOn, options));
}
exports.filterRateOverrides = filterRateOverrides;
function doesOverrideMatchInsurance(matchOn, options) {
    const matchingConditions = matchOn.conditions.filter(condition => doesConditionMatchInsurance(condition, options));
    const requiredMatchCount = matchOn.logicalOperator === models_1.RateOverrideLogicalOperator.And
        ? matchOn.conditions.length
        : OR_LOGICAL_OPERATOR_MATCH_REQUIREMENT;
    return matchingConditions.length >= requiredMatchCount;
}
function doesConditionMatchInsurance(condition, options) {
    const optionValue = options[condition.option];
    if (!optionValue) {
        return false;
    }
    switch (condition.comparisonOperator) {
        case models_1.RateOverrideComparisonOperator.Equal:
            return optionValue === condition.value;
        case models_1.RateOverrideComparisonOperator.LessThan:
            return optionValue < condition.value;
        case models_1.RateOverrideComparisonOperator.GreaterThan:
            return optionValue > condition.value;
        case models_1.RateOverrideComparisonOperator.NotEqual:
            return optionValue !== condition.value;
        case models_1.RateOverrideComparisonOperator.Contains:
            return doesValueContainString(optionValue, condition.value);
        default:
            return false;
    }
}
function doesValueContainString(optionValue, conditionValue) {
    const stringOptionValue = optionValue.toString().toLowerCase();
    const stringConditionValue = conditionValue.toString().toLowerCase();
    return stringOptionValue.includes(stringConditionValue);
}
//# sourceMappingURL=rate-override-filterer.js.map